export default "__VITE_ASSET__ydap$2Al__"